var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { } from "@angular/core";
import { ImageService } from "../../../services/image.service";
import { BaseComponent } from "../../../common/components/base.component";
import { MatDialogRef } from "@angular/material";
import { VisitorApiService } from "../../../services/visitor.api.service";
import { ResizeImageModalActions, ResizeImageModalData, } from "./resize.image.modal.provider";
import { ImageCropperWithPreviewComponent } from '../../../common/components/image.cropper/image.cropper.component';
var ResizeImageModalComponent = /** @class */ (function (_super) {
    __extends(ResizeImageModalComponent, _super);
    function ResizeImageModalComponent(dialogRef, actions, imageService, apiService, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.imageService = imageService;
        _this.apiService = apiService;
        _this.imageData = { image: null };
        _this.isImgLoaded = false;
        _this.data = Object.assign({}, data);
        _this.cropperSettings = _this.imageService.createImageCropperSetting(640, 480, false, 200);
        return _this;
    }
    ResizeImageModalComponent.prototype.ngAfterViewInit = function () {
        this.loadImage();
    };
    ResizeImageModalComponent.prototype.loadImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.data || !this.data.data) {
                    console.log("no data in resize image modal");
                    return [2 /*return*/];
                }
                // Ensure cropper is initialized
                if (!this.cropper) {
                    setTimeout(function () { return _this.loadImage(); }, 100);
                    return [2 /*return*/];
                }
                if (this.imageService.isBase64Image(this.data.data)) {
                    this.setImageToCropper(this.data.data);
                }
                else {
                    this.apiService
                        .getImageBase64(this.imageService.imageSourceUrl(this.data.data))
                        .subscribe({
                        next: function (res) {
                            if (res && res.succeed) {
                                _this.setImageToCropper(res.base64);
                            }
                        },
                        error: function (error) { return console.error("Error loading image:", error); },
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    ResizeImageModalComponent.prototype.setImageToCropper = function (base64Data) {
        var _this = this;
        var image = new Image();
        image.onload = function () {
            _this.cropper.setImage(image);
            _this.imageData.image = base64Data;
            _this.isImgLoaded = true;
        };
        image.src = base64Data;
    };
    ResizeImageModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    ResizeImageModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.actions.confirm(event, this.imageData.image);
                this.dialogRef.close();
                return [2 /*return*/];
            });
        });
    };
    return ResizeImageModalComponent;
}(BaseComponent));
export { ResizeImageModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/resize.image.modal/resize.image.modal.component.ts.pre-build-optimizer.js